const deleteFromObject = (obj: any, ignores?: string[]) => {
  let newObj = { ...obj };
  if (!ignores || !ignores.length) return obj;
  ignores.map(item => delete newObj[item]);
  return newObj;
};
export default deleteFromObject;
